import { h } from "preact";
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, SaveOutlined, SyncOutlined } from '@ant-design/icons';


export function getCognitoStatusIcon(status) {

    const cognitoStatusIconMap = {
        "UNCONFIRMED": <CloseCircleOutlined />,
        "CONFIRMED": <CheckCircleOutlined />,
        "ARCHIVED": <SaveOutlined />,
        "COMPROMISED": <ExclamationCircleOutlined />,
        "UNKNOWN": <ExclamationCircleOutlined />,
        "RESET_REQUIRED": <SyncOutlined spin />,
        "FORCE_CHANGE_PASSWORD": <SyncOutlined spin />
    }

    return cognitoStatusIconMap[status];
}

export function getCognitoStatusType(status) {

    const cognitoStatusTypeMap = {
        "UNCONFIRMED": "error",
        "CONFIRMED": "success",
        "ARCHIVED": "default",
        "COMPROMISED": "error",
        "UNKNOWN": "default",
        "RESET_REQUIRED": "processing",
        "FORCE_CHANGE_PASSWORD": "processing"
    }

    return cognitoStatusTypeMap[status];
}

export function getQualifiedCognitoStatusName(status) {

    const qualifiedStatusName = status.toLowerCase().split("_").join(" ");

    return qualifiedStatusName;
}